<script>
import FormComponent from './Form/component.vue';
import ItemComponent from './Item/component.vue';


export default {
  components: {
    FormComponent,
    ItemComponent,
  },
  props: {
    module: {
      type: Object,
    },
    link: String,
  },
  data: () => ({
    init: false,
    list: true,
  }),
  methods: {
    handlerSubmit() {
      this.module.submit()
        .finally(() => {
          this.init = true;
        });
    },
    toggleList() {
      this.list = !this.list;
    },
    handlerDelete2(index, row) {
      this.delete(row);
    },
    handlerDelete(item) {
      this.delete(item);
    },
    delete(item) {
      this.loading = true;
      this.module
        .del(item)
        .then((data) => {
          if(data.IsDeleted){
            this.$core.notify.info("Тур удален")
          }
          else {
            this.$core.notify.error("Тур нельзя удалить")
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
};
</script>
<template>
  <div class="app-template-page__body">
    <div class="tour-list-form">
      <FormComponent
        :module="module.form"
        @submit="handlerSubmit"

      />
    </div>
    <div class="list-card__pagination">
      <div class="list-card__pagination-left">
        <div class="list__btns">
          <Button class="el-button el-button--small" :class=" !list ? 'el-button--primary' : ' el-button--default'" @click="toggleList">
                    Расширенный режим
          </Button>
        </div>
      </div>
    </div>
    <div class="p-t-c-l__flex wrap" v-if="init && list">
      <div class="p-t-c-l__items">
        <ItemComponent
          v-for="item in module.__items"
          :item="item"
          :link="link"
          :key="item.id"
          class="p-t-c-l__item"
          @handlerDelete="handlerDelete"
        />

        <div
          v-if="!module.__items.length"
          class="p-t-c-l__error"
        >Туры не найдены
        </div>
      </div>
    </div>
    <div class="p-t-c-l__flex" v-if="init && !list">
      <el-table
        :data="module.__items"
        stripe
        style="width: 100%">
        <el-table-column
          width="20"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="Название">
        </el-table-column>

        <el-table-column
          prop="tourTypeName"
          label="Тип тура"
          width="160">
        </el-table-column>

        <el-table-column
          prop="ownerLegalName"
          label="Юр.лицо"
          width="180">
        </el-table-column>

        <el-table-column
          prop="cityName"
          label="Город отправления"
          width="160">
        </el-table-column>

        <el-table-column
          prop="countryName"
          label="Страна"
          width="160">
        </el-table-column>

        <el-table-column
          prop="departureCityName"
          width="160"
          label="Город прибытия">
        </el-table-column>

        <el-table-column
          prop="duration"
          label="Прод-ть"
          width="100"
          title="продолжительность">
        </el-table-column>

        <el-table-column
          width="150"
        >
          <template slot-scope="scope">
            <router-link
              v-if="$core.permission.has(361)"
              slot="btn"
              :to="`/admin/tour/${scope.row.id}`"
              style="margin-left: 16px;"
            >
              <button type="button" class="el-button el-button--primary el-button--small" > <i class="el-icon-edit"></i></button>
            </router-link>
            <button type="button" class="el-button el-button--danger el-button--small"  style="margin-left: 5px"
                    v-if="$core.permission.has(362)"
                    @click="handlerDelete2(scope.$index, scope.row)"><i class="el-icon-delete"></i></button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<style lang="scss">
.list-card__pagination {
  background: #f3f5f4;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border: 1px solid #d5dfe7;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;

  .list__btns {
    padding: 5px 0px;
    margin-left: 7px;
  }
  .el-button--default{
    color: #606266;
    background-color: transparent;
    border-color: transparent;
    border-color:#dcdfe6 ;
  }
  .el-button--primary{
    color: #fff;
    background-color: #6db234;
    border-color: #6db234;
  }
  .el-button:hover {
    color: #6db234;
    border-color: #d3e8c2;
    background-color: #f0f7eb;
  }
  .el-button--primary:hover {
    background: #8ac15d;
    border-color: #8ac15d;
    color: #fff;
  }
}
  .p-t-c-l {
    &__flex {
      display: flex;
      .el-button--primary {
        color: #FFFFFF;
        background-color: #6db234;
        border-color: #6db234;
      }
    }

    &__filter {
      width: 300px;
      flex-shrink: 0;
      margin: 0 24px 0 0;
    }

    &__items {
      flex: 1;
    }

    &__error {
      text-align: center;
      padding: 36px;
    }
  }

  @media (max-width: 1000px) {
    .p-t-c-l__filter {
      display: none;
    }
  }
</style>
